import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export function ForgotPasswordPage() {
  const { resetPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      await resetPassword(email)
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', background: '#F7FAFC' }}>
      <div style={{ width: '100%', maxWidth: '400px', background: '#FFFFFF', borderRadius: '12px', padding: '2rem', boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}>
        <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: '24px', fontWeight: 500, color: '#1A202C', marginBottom: '1rem' }}>
          Reset your password
        </h1>

        {sent ? (
          <div>
            <p style={{ color: '#4A5568', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              If an account exists for <strong>{email}</strong>, we&rsquo;ve sent a password reset link to that address.
            </p>
            <Link to="/login" style={{ color: '#2C7A7B', textDecoration: 'none', fontWeight: 500 }}>Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: '#4A5568', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              Enter your email and we&rsquo;ll send you a link to reset your password.
            </p>

            <div style={{ marginBottom: '1rem' }}>
              <label htmlFor="email" style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#4A5568', marginBottom: '6px' }}>Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #E2E8F0', borderRadius: '6px', fontSize: '15px' }}
                autoComplete="email"
              />
            </div>

            {error && (
              <div style={{ padding: '10px 12px', background: '#FAECE7', color: '#993C1D', borderRadius: '6px', fontSize: '13px', marginBottom: '1rem' }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '11px',
                background: '#2C7A7B',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '6px',
                fontSize: '15px',
                fontWeight: 500,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>

            <p style={{ marginTop: '1rem', fontSize: '14px', color: '#4A5568' }}>
              Remember your password? <Link to="/login" style={{ color: '#2C7A7B', textDecoration: 'none', fontWeight: 500 }}>Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  )
}
